import { createContext, useContext } from 'react';
import type { ProjectScope } from '../features/sync/project-scope';

export interface JobProgressContextValue {
    startJobTracking: (
        scope: ProjectScope,
        jobId?: string,
        sourceFile?: string,
        importMode?: 'replace' | 'append',
    ) => void;
    stopJobTracking: () => void;
    isTracking: boolean;
}

export const JobProgressContext = createContext<JobProgressContextValue | null>(null);

export const useJobProgress = (): JobProgressContextValue => {
    const context = useContext(JobProgressContext);
    if (!context) throw new Error('useJobProgress must be used within JobProgressProvider');
    return context;
};
